import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '..'

export const cartReservationsLenghtSelector = createSelector(
  [cartSlice.selectors.cartReservations],
  (cartReservations) => cartReservations.length
)
